import { css } from 'linaria';

export const popularSwiper = css`
  && {
    @media (--from-desktop) {
      padding: 15px;
      margin: -15px;
    }

    @media (--to-desktop) {
      padding-top: 15px;
      padding-bottom: 15px;
      margin-top: -15px;
      margin-bottom: -15px;
    }

    .swiper-button-prev,
    .swiper-button-next {
      top: 138px;
    }
  }
`;

export const popularSlide = css`
  && {
    width: 220px;
    height: 204px;
    margin-right: 20px;
    border-radius: var(--rounding-l);
    box-shadow: 0 2px 9px rgb(0 0 0 / 2%), 0 1px 4px rgb(0 0 0 / 16%);

    &:last-of-type {
      margin-right: 0;
    }

    @media (--to-desktop) {
      width: 204px;
    }

    @media (--only-mobile) {
      margin-right: 16px;
    }
  }
`;

export const popularItem = css`
  width: 100%;
  height: 100%;
  overflow: hidden;

  &:hover img {
    transform: scale(1.1);
  }
`;

export const allPopularItem = css`
  && {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 56px;

    ::before {
      position: absolute;
      top: 63px;
      left: 50%;
      width: 48px;
      height: 48px;
      background-color: var(--control-minor);
      background-image: url('https://cdn.lemanapro.ru/lmru/image/upload/fudzi/elbrus/images/landings/engineering-systems/swiper-arrow-2.png/swiper-arrow-2.png');
      background-repeat: no-repeat;
      background-position: center;
      background-size: 24px 24px;
      border-radius: 100%;
      transform: translateX(-50%);
      content: '';
    }

    &:hover {
      ::before {
        background-color: var(--control-hover-minor);
      }
    }
  }
`;

export const popularItemImgWrapper = css`
  width: 100%;
  height: 128px;
  overflow: hidden;
  border-radius: var(--rounding-l) var(--rounding-l) 0 0;
`;

export const popularItemImage = css`
  width: 100%;
  height: 100%;
  border-radius: var(--rounding-l) var(--rounding-l) 0 0;
  object-fit: cover;
`;

export const popularItemText = css`
  padding: 16px;
`;
